<template>
	<div class="e-leraning-videos">
		<div style="width: 100%; margin-bottom: 20px">
			<router-link to="/eLearning" exact class="btn-back">
				<img src="images/chevron-left-green.svg" class="mr-2" />powrót
			</router-link>
		</div>
		<div class="video-container">
			<div v-if="getSelectedVideo" id="player">
				<div class="bg-white p-5">
					<div class="text-center my-2">
						<img
							style="max-width: 200px"
							src="images/m-bank-ui-illustrations-retail-cross-mark-woman.svg"
							alt="Akceptacja cookies"
						/>
					</div>
					<div class="px-3">
						Nie możemy Ci pokazać wideo na stronie bez Twojej zgody
						na ciasteczka analityczne i marketingowe. Wynika to z
						ograniczeń technicznych. Zmień zgodę w
						<span
							@click="openCookieModal"
							style="color: #00801f; cursor: pointer"
							>Ustawieniach cookie</span
						>
					</div>
				</div>
			</div>
			<h5>
				sekcja {{ getSelectedVideo.id }} - {{ getSelectedVideo.name }}
			</h5>
			<h2>{{ getSelectedVideo.movieName }}</h2>
			<h1 id="display"></h1>
			<p>UWAGA! Przewijanie lekcji nie przyspiesza jej zaliczenia.</p>
		</div>
		<transition name="fade" mode="out-in">
			<div class="video-container-boxes">
				<learning-box-collapse
					v-for="(course, i) in getCourses"
					:key="i"
					:id="course.id"
					:name="course.name"
					:movies="course.movies"
					:finishedLessons="finished(course.movies)"
					:lessonsTime="learningTime(course.movies)"
					:isTestReady="isTestReady()"
					:player="player"
					:changeVideo="changeVideo"
				/>
				<learning-box-collapse
					:id="0"
					:key="'test'"
					:name="'Test wiedzy'"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import LearningBoxCollapse from './partial/LearningBoxCollapse';
import { eLearningMethods, eLearningLessons } from '@/mixins/e-learning.js';
export default {
	data() {
		return {
			courses: null,
			leavePage: false,
			changePath: '',
			player: null,

			watchedVideo: [],
			countTime: 0,
			extraTime: false,
			timeInterval: null,
			timeSpent: [],
			changeVideo: true,
			pauseVideo: false,
			recordTime: null,
		};
	},
	mixins: [eLearningMethods, eLearningLessons],
	components: {
		LearningBoxCollapse,
	},
	computed: {
		...mapGetters(['getSelectedVideo', 'getCourses']),
	},
	methods: {
		isTestReady() {
			let isAllFinished = [];
			Array.prototype.forEach.call(this.getCourses, (course) => {
				for (var i = 0; i < course.movies.length; i++) {
					isAllFinished.push(course.movies[i].done);
				}
			});
			return isAllFinished.find((item) => item === false) === false
				? 'e-learning-box-disabled'
				: 'e-learning-box-success';
		},
		async showPercentage() {
			this.countTime = 0;
			for (var i = 0, l = this.timeSpent.length; i < l; i++) {
				if (this.timeSpent[i]) this.countTime++;
			}
			this.countTime = Math.round(
				(this.countTime / this.timeSpent.length) * 100
			);

			if (document.getElementById('display')) {
				document.getElementById('display').innerText =
					this.countTime + '%';
			}
		},
		async record() {
			if (!this.pauseVideo && this.timeSpent.length) {
				let oldTime = this.recordTime;
				this.recordTime = parseInt(this.player.getCurrentTime());
				if (oldTime) {
					for (var i = oldTime; i < this.recordTime; i++) {
						this.timeSpent[i] = true;
					}
				}
				if (this.$checkIfSoonExpiration() && !this.pauseVideo) {
					await this.$store.dispatch('fetchRefreshToken');
				}

				this.timeSpent[this.recordTime] = true;
				this.showPercentage();
			}
		},

		clearRecord() {
			this.countTime = 0;
			this.timeSpent = [];
			this.changeVideo = true;
			this.pauseVideo = false;
			this.extraTime = false;
			clearInterval(this.timeInterval);
		},

		onPlayerStateChange(event) {
			// Koniec filmu
			if (event.data === 0) {
				this.pauseVideo = true;
				// Sprawdzenie czy film został zakońcozny i obejrzany - przewinięcie do końca video sie nie liczy
				if (this.countTime >= 97) {
					this.changeVideo = false;

					this.$store.commit(
						'setWatchedMovieId',
						this.getSelectedVideo.movieId
					);
					this.$store.dispatch('doneToken');

					this.getCourses.forEach((course) => {
						for (var i = 0; i < course.movies.length; i++) {
							if (
								course.movies[i].src ==
								this.getSelectedVideo.movieSrc
							) {
								course.movies[i].done = true;
							}
						}
					});
				}
			}

			//Start Video
			else if (event.data === 1) {
				this.timeInterval = setInterval(this.record, 500);

				if (!this.changeVideo) {
					this.clearRecord();
				}
				if (!this.timeSpent.length) {
					for (
						var i = 0, l = parseInt(this.player.getDuration());
						i < l;
						i++
					)
						this.timeSpent.push(false);
				} else if (this.timeSpent.length && this.pauseVideo) {
					this.pauseVideo = false;
				} else {
					this.changeVideo = true;
				}
			}
			//Pauza video
			else if (event.data === 2) {
				this.recordTime = null;

				// Nie dodajemy już dodatkowego czasu przy zatrzymaniu video

				// if (!this.extraTime) {
				// 	this.extraTime = true;
				// 	let currentTime = new Date(
				// 		sessionStorage.getItem('expirationDate')
				// 	);
				// 	let expirationDate = new Date(
				// 		currentTime.getTime() + 300000
				// 	);
				// 	sessionStorage.setItem('expirationDate', expirationDate);
				// }
				this.pauseVideo = true;
				clearInterval(this.timeInterval);
			}
		},
		onYouTubeIframeAPIReady() {
			this.player = new window.YT.Player('player', {
				videoId: this.getSelectedVideo.movieSrc,
				events: {
					onStateChange: this.onPlayerStateChange,
				},
			});
		},

		// Wyświetlenie modala Cookie - mbiscuit z gtm mBanku
		openCookieModal() {
			// eslint-disable-next-line
			mbiscuit.open();
		},
	},
	beforeMount() {
		this.$store.commit('setChangePath', false);
		this.getCourses ? '' : this.$store.dispatch('fetchCourses');
		this.$store.commit('setIsLeaving', false);
		this.extraTime = false;
		localStorage.setItem('videoSection', 1);
		window.onbeforeunload = function () {
			localStorage.removeItem('videoSection');
		};
	},
	mounted() {
		this.onYouTubeIframeAPIReady();
	},
	beforeRouteLeave(to, from, next) {
		if (this.changeVideo && this.$store.getters.getCurrentUser) {
			this.player.pauseVideo();
			this.$store.commit('setIsLeaving', true);
			this.$store.commit('setLearningModal', true);
			this.$store.commit('setPath', to.path);
			let accpet = this.$store.getters.getChangePath;
			if (accpet) {
				this.$store.commit('setChangePath', false);
				next();
			}
		} else {
			next();
		}
	},
	beforeUnmount() {
		// wyczyszczenie danych zliczających obejrzany film
		localStorage.removeItem('videoSection');
		this.$store.commit('setLearningModal', false);
		this.clearRecord();
	},
	watch: {
		getSelectedVideo() {
			this.player.loadVideoById(this.getSelectedVideo.movieSrc);
			this.clearRecord();
			this.timeInterval = setInterval(this.record, 500);
		},
	},
};
</script>
